<app-index-layout>
  <div box-body>
    <h3>Thank you for using the Support Portal!</h3>
    <p class="pt-2">If you would like to log back in, click here:</p>
    <a routerLink="/">Log back into Support Portal</a>
  </div>
</app-index-layout>
